import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
    selector: "[focusOnInit]",
})
export class FocusRefDirective {
    @Input()
    public set focusOnInit(value) {
        if (value === true) {
            this.focus();
        }
    }

    constructor(private elementRef: ElementRef) { }

    public focus() {
        this.elementRef.nativeElement.focus();
    }
}
